import axios from 'axios';
import Vue from 'vue';
import Vuesax from 'vuesax';

Vue.use(Vuesax)
import router from '../router';
const vue = new Vue({
  router,
});

let showNoToken = true;
const service = axios.create({
  baseURL: process.env.VUE_APP_API, // api 的 base_url
  timeout: 30000 // request timeout
});

function clearAndJump(){
  window.localStorage.clear();
  let selfQuery = {
    ...vue.$route.query,
  }
  if(vue.$route.name !== 'login'){
    selfQuery.redirectRouterName = vue.$route.name
  }
  router.push({
    name:'login',
    query: selfQuery,
    params: vue.$route.params,
  });
}

// request interceptor
service.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);

    config.headers = {
      "Content-Type":'application/json;charset=UTF-8',
    };
    let tokenX = localStorage.getItem('token');
    if(tokenX){
      config.headers['Authorization'] = "Bearer " + tokenX
    }
    let domain = process.env.NODE_ENV === 'production' ? window.location.origin : '';
    if(domain.indexOf('https') > -1){
      config.baseURL=config.baseURL.replace('http','https');
    }
    return config;
  },
  error => {

    console.log('requestErr' + error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.data.status !== 10000 && vue.$route.name != 'cashier') {
      // 样式层级不够高 todo 翻译
      vue.$vs.dialog({
        title: '注意',
        text: response.data.message
      });
      return Promise.reject(response);
    }
    // 收银台
    if (response.data.code == 'f' && vue.$route.name == 'cashier') {
      vue.$vs.dialog({
        title: '注意',
        text: response.data.message
      });
      return Promise.reject(response);
    }
    if(response.data.type==2){
      response.data.data = response.data.data.content;
    }else if(response.data.type==3){
      response.data.data = response.data.data.content[0]
    }
    return response.data;
  },
  error => {
    console.log(error);
    const errStatus = error.response && error.response.status;
    if(errStatus == 401){
      //区分没有登录和登录过token失效
      if(!localStorage.getItem('token') && vue.$route.name != 'login' && showNoToken){
        showNoToken = false;
        // token失效之后的重定向 todo
        vue.$router.push({name: 'login'});
      }else {
        //登录异常
        if(showNoToken){
          showNoToken = false;
          setTimeout(() => {
            clearAndJump();
          }, 3000);

          vue.$vs.dialog({
            type: vue.$i18n.t('Login.loginTimeout'),
            color: 'danger',
            title: `Confirm`,
            text: vue.$i18n.t('Login.loginTimeoutTip'),
            accept: () => {
              clearAndJump();
            }
          });
        }
      }
    }else{
      console.error(error);
    }

    return Promise.reject(error);
  }
);
export default service;
